export function pushToDataLayer(
  data: {
    event:
      | "sign_up"
      | "sign_in"
      | "purchase"
      | "upgrade"
      | "chatbot_created"
      | "chatbot_launched";
  } & Record<string, string | number>,
) {
  try {
    if (window.IS_EMBEDDED || window.DISABLE_TRACKING) {
      console.log("GTM tracking disabled - embedded context");
      return;
    }
    window.dataLayer.push(data);
  } catch (error) {
    console.log(error);
  }
}
